import { Injectable } from '@angular/core';
import { IAppConfig } from './models/app-config';
import { SessionStorageService } from './storage/session-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private appConfig: IAppConfig = {} as IAppConfig;
  private postLoginRedirectUrl = '';
  private loaded = false;

  constructor(private readonly sessionStorageService: SessionStorageService) {}

  loadConfig() {
    if (this.loaded) {
      return;
    }

    const authConfig = this.sessionStorageService.getItem('authConfig');
    const postLoginUrl = this.sessionStorageService.getItem('postLoginRedirectUrl');

    this.appConfig = authConfig ? JSON.parse(authConfig) : ({} as IAppConfig);
    this.postLoginRedirectUrl = postLoginUrl ?? '';

    this.sessionStorageService.removeItem('authConfig');
    this.sessionStorageService.removeItem('postLoginRedirectUrl');

    this.loaded = true;
  }

  get config(): Readonly<IAppConfig> {
    return this.appConfig;
  }

  get postLoginUrl(): string {
    return this.postLoginRedirectUrl;
  }
}
